import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OgoResponseItems } from './ogo-response';
import { ClusterRef } from '../models/refs';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
  ) {}

  public diagnose(diagRequest: DiagRequest): Observable<DiagResult> {
    return this.http.post<DiagResult>('v2/sites/diagnose', diagRequest);
  }

  public resolveDns(hostName: string) {
    return this.http.post<ResolveResponse>('v2/sites/resolve', { hostName });
  }

  public getStatuses(): Observable<SiteStatus[]> {
    return this.http
      .post<OgoResponseItems<{ code: string; libelle: string; libelleEn: string }>>('statutHote/get', { data: {} })
      .pipe(
        map((response) =>
          response.items.map((status) => ({
            code: status.code,
            label: this.auth.getCurrentLanguage() === 'en' ? status.libelleEn : status.libelle,
          })),
        ),
      );
  }
}

type DiagRequest = {
  cluster: ClusterRef;
  domainName: string;
  originServer: string;
  originScheme: UrlScheme;
  originMtlsEnabled?: boolean;
  originPort?: number;
  originSkipCertVerify?: boolean;
};

export interface DiagResult {
  issueDetected: boolean;
  backends: { [prop: string]: DiagBackend };
}

export interface DiagBackend {
  resolvStatus: DiagStatus;
  ips: { [prop: string]: DiagIp };
}

export type DiagIp = { [prop: string]: Diag };

export interface Diag {
  status: DiagStatus;
  issues: string[];
}

export type DiagStatus = 'OK' | 'KO';

export const UrlSchemes = ['http', 'https'] as const;
export type UrlScheme = (typeof UrlSchemes)[number];

export type ResolveResponse = Partial<{
  name: string;
  ipv4: string[];
  ipv6: string[];
  cname: string;
}>;

export type SiteStatus = {
  code: string;
  label: string;
};
